import { useEffect, useState } from 'react'
import { loadYandexMaps, isYandexMapsApiConfigured } from '@/lib/yandexMapsLoader'

export function useYandexMaps() {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    loadYandexMaps()
      .then(() => setReady(true))
      .catch(() => {})
  }, [])

  return { ready, isConfigured: isYandexMapsApiConfigured() }
}
